export class DataReportingFilters {
  applicantFirstName?: string;
  applicantMiddleName?: string;
  applicantLastName?: string;
  applicationId?: string;
  isSubmitted?: string;
  submittedOn?: string;
  applicantEmail?: string;
  accountVerified?: boolean;
  createdAt?: string;
  maritalStatus?: string;
}
